<div fxLayout="column" fxLayoutAlign="start start" class="h-100 w-100">
    <div fxLayout="row" fxLayoutAlign="end center" class="w-100 t4 c-primary-gray-600">
        @if (totalElementsTitle) {
            <div> {{ totalElementsTitle }}</div>
        }
    </div>
    <div class="w-100 h-100"
         [class.mt-16]="totalElementsTitle"
         [class.overflow-y-scroll]="enableScroll"
         [class.overflow-x-scroll]="enableScroll"
         fxLayout="column"
         fxFlex>
        <table mat-table [dataSource]="dataSource" class="hide-scroll-bar"
               [multiTemplateDataRows]="true"
               [class.without-border]="withoutBorder">
            @for (column of displayedColumns; track column) {
                <ng-container [matColumnDef]="column">
                    <th mat-header-cell *matHeaderCellDef
                        [class.medium]="height === 'medium'"
                        [class.without-border]="withoutBorder"
                        [class.with-header-background]="withHeaderBackground"
                        [class.max-width-for-checkbox]="column === 'select'"
                        [class.max-width-for-button]="column.toLowerCase().includes('button')"
                        class="t4 no-wrap"
                        [class.pointer]="sortableColumns.includes(column)"
                        (click)="sortableColumns.includes(column) && sortTable(column)">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <div>
                                {{
                                    (column.toLowerCase().includes('button') || column === 'select')
                                        ? ''
                                        : ((addTranslationPrefix
                                            ? 'i18n_af_column#' + (columnTranslationPrefixes[column]
                                            ? columnTranslationPrefixes[column] + '_'
                                            : '')
                                            : '') + column | translate)
                                }}
                            </div>
                            @if (sortableColumns.includes(column)) {
                                <ui-kit-svg
                                    class="i-24 sort-by"
                                    [class.desc]="sortedBy?.columnName === column && sortedBy?.direction === 'desc'"
                                    name="ic_sorted_by">
                                </ui-kit-svg>
                            }
                        </div>
                    </th>
                    <td #cells mat-cell *matCellDef="let element" class="t5 c-primary-gray-900"
                        [class]="element.rowStyle"
                        [class.without-border]="withoutBorder"
                        [class.max-width-for-button]="element[column]?.type === ColumnType.BUTTON"
                        [class.crop-text-column]="element[column]?.cellStyle?.ellipsisText"
                        [class.crop-text-column-medium]="element[column]?.cellStyle?.ellipsisTextMedium"
                        [class.crop-text-column-large]="element[column]?.cellStyle?.ellipsisTextLarge"
                        [matTooltip]="element[column]?.tooltip?.text | translate"
                        matTooltipClass="pre-line">
                        @if (element[column]?.type === ColumnType.TEXT) {
                            <div class="no-wrap">{{ element[column].text | translate }}</div>
                        }
                        @if (element[column]?.type === ColumnType.STATUS) {
                            <div class="w-100" fxLayout="column" fxLayoutAlign="start start">
                                <af-status [status]="element[column].style" [statusText]="element[column].text">
                                </af-status>
                            </div>
                        }
                        @if (element[column]?.type === ColumnType.CUSTOM_LAYOUT) {
                            <div class="no-wrap"
                                 [fxLayout]="element[column].cellStyle?.layoutDirection || 'column'"
                                 [fxLayoutAlign]="element[column].cellStyle?.layoutAlignFirst + ' ' + element[column].cellStyle?.layoutAlignSecond"
                                 [fxLayoutGap]="element[column].cellStyle?.layoutGap">
                                @for (item of element[column].layoutContentItems; track item) {
                                    @if (item.type === 'text') {
                                        <div class="no-wrap"
                                             [class.pointer]="item.click"
                                             [class.c-primary-green-800]="item.click"
                                             (click)="$event.stopPropagation(); item.click && item.click()">
                                            {{ item.text | translate }}
                                        </div>
                                    }
                                    @if (item.type === 'icon') {
                                        <ui-kit-svg [ngClass]="item.iconSize || 'i-16'"
                                                    [name]="item.text"
                                                    [class.c-primary-green-800]="!item.iconColor && !item.disabled"
                                                    [class]="item.iconColor"
                                                    [class.c-primary-gray-200]="item.disabled"
                                                    [class.pointer]="item.click"
                                                    (click)="!item.disabled && $event.stopPropagation(); item.click && item.click()"
                                                    [matTooltip]="item.tooltip | translate">
                                        </ui-kit-svg>
                                    }
                                }
                            </div>
                        }
                        @if (element[column]?.type === ColumnType.LOGO) {
                            <backoffice-bank-logo [logoUrl]="element[column].logoUrl"
                                                  [bankName]="element[column].text">
                            </backoffice-bank-logo>
                        }
                        @if (element[column]?.type === ColumnType.DATE) {
                            <div class="no-wrap">{{ element[column].text | date:'dd.MM.yyyy' }}</div>
                        }
                        @if (element[column]?.type === ColumnType.LINK) {
                            <div class="no-wrap underlined-text c-primary-green-800"
                                 [class.pointer]="element[column]?.click"
                                 (click)="element[column]?.click()">
                                {{ element[column].text }}
                            </div>
                        }
                        @if (element[column]?.type === ColumnType.MASKED_TEXT) {
                            <div class="no-wrap">
                                {{
                                    element[column].text | mask: (element[column]?.mask || ''): {
                                        prefix: element[column]?.prefix || '',
                                        specialCharacters: element[column]?.specialCharacters || ''
                                    }
                                }}
                            </div>
                        }
                        @if (element[column]?.type === ColumnType.TIME_MILLIS) {
                            <div class="no-wrap">{{ element[column].text | date:'HH:mm:ss.SSS' }}</div>
                        }
                        @if (element[column]?.type === ColumnType.DATETIME) {
                            <div class="no-wrap">{{ element[column].text | date:'dd.MM.yyyy HH:mm' }}</div>
                        }
                        @if (element[column]?.type === ColumnType.DATE_TIME_SECONDS) {
                            <div class="no-wrap">
                                {{ element[column].text | date:'dd.MM.yyyy HH:mm:ss' }}
                            </div>
                        }
                        @if (element[column]?.type === ColumnType.DATE_TIME_MILLIS) {
                            <div class="no-wrap">
                                {{ element[column].text | date:'dd.MM.yyyy HH:mm:ss.SSS' }}
                            </div>
                        }
                        @if (element[column]?.type === ColumnType.PRIORITY) {
                            <af-priority [priorityLevel]="element[column].text"/>
                        }
                        @if (element[column]?.type === ColumnType.MONEY) {
                            <div class="no-wrap">
                                {{ 'i18n_af_labelMoney' | translate : {money: element[column].text | tiynTenge | numberTriplesFormat} }}
                            </div>
                        }
                        @if (element[column]?.type === ColumnType.DIGITS) {
                            <div>{{ element[column].text | numberTriplesFormat }}</div>
                        }
                        @if (element[column]?.type === ColumnType.PROGRESS) {
                            <div class="w-100" fxLayout="column" fxLayoutAlign="start start">
                                <div class="t4">{{ element[column].text | number: '1.0-2' }} %</div>
                                <mat-progress-bar [value]="element[column].text"
                                                  class="progress mt-8"
                                                  [class]="element.rowStyle || style"
                                                  mode="determinate">
                                </mat-progress-bar>
                            </div>
                        }
                        @if (element[column]?.type === ColumnType.CHECKBOX){
                            <ui-kit-checkbox (click)="$event.stopPropagation()"
                                             appearance="small"
                                             [withLabel]="false"
                                             [checked]="element[column]?.isChecked"
                                             [disabled]="element[column]?.isDisabled"
                                             (change)="element.isSelected = $event.checked; element[column].change?.($event.checked)"
                                             class="max-width-for-checkbox"/>
                        }
                        @if (element[column]?.type === ColumnType.BUTTON) {
                            @if (element[column].text) {
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <ui-kit-button [type]="element[column].buttonType || 'text'"
                                                   [iconPosition]="element[column].iconPosition || 'right'"
                                                   [color]="element[column].color || 'primary'"
                                                   [size]="element[column].buttonSize || 'regular'"
                                                   [fitContent]="element[column].additionalIcons?.length"
                                                   [spinnerId]="element[column].spinnerId"
                                                   [icon]="element[column].icon"
                                                   [label]="element[column].text | translate"
                                                   (clickListener)="element[column].click()"/>
                                    @if (element[column].additionalIcons?.length) {
                                        @for (icon of element[column].additionalIcons; track icon) {
                                            <ui-kit-svg
                                                class="i-16 ml-4 pointer c-primary-green-800"
                                                (click)="$event.stopPropagation(); icon.click()"
                                                [name]="icon.name">
                                            </ui-kit-svg>
                                        }
                                    }
                                </div>
                            }
                        }
                    </td>
                </ng-container>
            }
            @if (expandableColumnName) {
                <ng-container matColumnDef="expand">
                    <th mat-header-cell *matHeaderCellDef class="t6 expandable"></th>
                    <td mat-cell *matCellDef="let element" class="t5 c-primary-gray-900 expandable"
                        [class]="element.rowStyle || style"
                        (click)="(expandedElement = expandedElement === element ? null : element);
                           $event.stopPropagation();">
                        @if (element[expandableColumnName].data.length) {
                            <ui-kit-svg class="i-16 c-primary-gray-900"
                                        [name]="expandedElement === element ? 'ic_arrow_down' : 'ic_arrow_right'">
                            </ui-kit-svg>
                        }
                    </td>
                </ng-container>
                <ng-container [matColumnDef]="expandableColumnName">
                    <td mat-cell *matCellDef="let element"
                        class="t5 c-primary-gray-900 expanded"
                        [class]="element.rowStyle || style"
                        [class.without-border]="withoutBorder"
                        [attr.colspan]="displayedColumnsWithExpandable.length">
                        <div class="expandable-container" fxLayout="column"
                             [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                            @for (item of element[expandableColumnName].data; track item) {
                                <div class="table-data-container">
                                    <div class="data-cell">
                                        {{ item.name }}
                                    </div>
                                    <div class="data-cell">{{ item.value }}</div>
                                </div>
                            }
                        </div>
                    </td>
                </ng-container>
            }
            <tr mat-header-row *matHeaderRowDef="displayedColumnsWithExpandable; sticky: enableStickyHeader;"
                [class.without-border]="withoutBorder">
            </tr>
            <tr mat-row
                *matRowDef="let row; columns: displayedColumnsWithExpandable;"
                [class.pointer]="row.click || expandableColumnName"
                [class.min-height-56]="height === 'default'"
                [class.min-height-72]="height === 'big'"
                [class.min-height-60]="height === 'medium'"
                [class.expanded]="expandedElement === row"
                [class]="row.rowStyle || style"
                (click)="handleRowClick(row)">
            </tr>
            @if (expandableColumnName) {
                <tr mat-row *matRowDef="let row; columns: [expandableColumnName];" class="expandable-row"
                    [class]="row.rowStyle || style"></tr>
            }
        </table>
    </div>
</div>
